import { FeaturesList } from "@/components";
import React from "react";

export const DeveloperFeatures = () => {
  return <FeaturesList showEdit={true} showDelete={true} />;
};
